import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Play } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { trackCTAClick } from '@/lib/metaPixel';

export const MobileStickyBar = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: "spring", stiffness: 300, damping: 30 }}
          className="fixed bottom-0 left-0 right-0 z-50 sm:hidden"
        >
          <div className="bg-white border-t border-border shadow-lg px-4 py-3 safe-area-bottom">
            <div className="flex items-center gap-3">
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-foreground truncate">Start Free</p>
                <p className="text-xs text-muted-foreground">No credit card required</p>
              </div>
              <Link to="/apply?plan=free" onClick={() => trackCTAClick('Free Class Sticky', 'MobileStickyBar')}>
                <Button
                  className="bg-primary hover:bg-primary/90 active:scale-[0.98] text-primary-foreground h-12 px-6 rounded-xl font-semibold flex-shrink-0"
                >
                  <Play className="w-4 h-4 mr-1.5" />
                  Free Class
                </Button>
              </Link>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MobileStickyBar;
